import React from 'react';
import { DirectButton } from '../../../../../direct/direct-button/direct-button';
import Helpers from '../../../../../utils/helper';
import { PmgMembershipProfile } from '../../../../../models/PmgMembershipProfile/PmgMembershipProfile';
import { useStateSelector } from '../../../../../store/selectors';

interface PmgMembershipProfileAffiliatedPracticeRepresentativeSectionProps {
    membershipData: PmgMembershipProfile;
    isEditVisible: boolean;
    isUserAdmin: boolean;
    onApplyToChange: () => void;
    onDirectButtonClick: () => void;
}

const PmgMembershipProfileAffiliatedPracticeRepresentativeSection: React.FC<
    PmgMembershipProfileAffiliatedPracticeRepresentativeSectionProps
> = ({
    membershipData,
    isEditVisible,
    isUserAdmin,
    onApplyToChange,
    onDirectButtonClick,
}) => {
    const limits = useStateSelector((state) => state.currentUser.limits);
    return (
        <div className="dynamic_data_content affiliated-practice-representative-section">
            <h6>Affiliated Practice Representative</h6>
            {isEditVisible ? (
                <div className="dynamic_data">
                    <label>Name</label>
                    <div className="name_change">
                        <span className="profile_data mr-3">
                            {membershipData?.practiceRepresentativeName}
                        </span>
                        {((isUserAdmin &&
                            membershipData?.hasPaidSubscription) ||
                            (limits && limits.hasPaidSubscription)) && (
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={onApplyToChange}>
                                Apply to Change
                            </button>
                        )}
                    </div>
                </div>
            ) : (
                <div className="dynamic_data name-container">
                    <label>Name</label>
                    <div className="name-container">
                        <span className="profile_data">
                            {membershipData?.practiceRepresentativeName}
                        </span>
                        <DirectButton
                            clickCallback={onDirectButtonClick}
                            memberId={
                                membershipData?.practiceRepresentativeUserId
                            }
                            size="small"
                        />
                    </div>
                </div>
            )}
            <div className="dynamic_data">
                <label>Role Name</label>
                {isEditVisible ? (
                    <input
                        type="text"
                        readOnly
                        className="form-control"
                        value={membershipData?.roleName || ''}
                    />
                ) : (
                    <span className="profile_data">
                        {membershipData?.roleName}
                    </span>
                )}
            </div>
            <div className="dynamic_data">
                <label>Mobile Phone</label>
                {isEditVisible ? (
                    <input
                        type="text"
                        readOnly
                        className="form-control"
                        value={Helpers.getFormattedPhoneNumberWithoutPrefix(
                            membershipData?.practiceRepresentativePhone
                        )}
                    />
                ) : (
                    <span className="profile_data">
                        {Helpers.getFormattedPhoneNumberWithoutPrefix(
                            membershipData?.practiceRepresentativePhone
                        )}
                    </span>
                )}
            </div>
            <div className="dynamic_data">
                <label>Email Address</label>
                {isEditVisible ? (
                    <input
                        type="email"
                        readOnly
                        className="form-control"
                        value={
                            membershipData?.practiceRepresentativeEmail || ''
                        }
                    />
                ) : (
                    <span className="profile_data">
                        {membershipData?.practiceRepresentativeEmail}
                    </span>
                )}
            </div>
        </div>
    );
};

export default PmgMembershipProfileAffiliatedPracticeRepresentativeSection;
